import { EditAdminUserModel } from '@idealsupply/ngclient-webservice-identity-server';

export class LoadUserRoles {
  static readonly type = '[UserRoles] Get all possible user roles';
  constructor() {}
}
